module.exports = __webpack_public_path__ + "images/bg-coupon-d.png";


//////////////////
// WEBPACK FOOTER
// ./src/static/images/bg-coupon-d.png
// module id = 833
// module chunks = 126